import type { Appear, Boundaries } from '@widgets/shared/types'
import type { ClickToTextPosition } from '@/services/domain/services/forms/clickToText/types'

/**
 * @deprecated
 */
export const WIDGET_MESSAGE_APPEAR = 'appear'
export const WIDGET_MESSAGE_RESIZE = 'resize'
export const WIDGET_MESSAGE_POSITION = 'position'

const sendWidgetMessage = (type: string, payload: any) => window.parent.postMessage({ type, payload }, '*')

/**
 * @deprecated
 */
export const sendWidgetAppearMessage = (appear: Appear) => sendWidgetMessage(WIDGET_MESSAGE_APPEAR, appear)
export const sendWidgetResizeMessage = (boundaries: Boundaries) => sendWidgetMessage(WIDGET_MESSAGE_RESIZE, boundaries)
export const sendWidgetPositionMessage = (position: ClickToTextPosition) =>
  sendWidgetMessage(WIDGET_MESSAGE_POSITION, position)

export const subscribeOnWidgetMessages = (callback: (type: string, payload: any) => void) =>
  window.addEventListener('message', ({ data: { type, payload } }) => callback(type, payload))
